// Test which use translation is throwing warning `You will need pass in an i18next instance by using i18nextReactModule`
// so this i18n for test only

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { i18nConfig } from "../../../client/i18n";

i18n.use(initReactI18next).init({
    lng: "en",
    ...i18nConfig,
});

i18n.t = i18n.t.bind(i18n);

export default i18n;
